import React, { useCallback } from "react";
import { useRef, useState } from "react";
import { Overlay, Popover } from "react-bootstrap";
import { OverlayChildren } from "react-bootstrap/Overlay";

interface PopoverCellProps {
  value: any;
  children: OverlayChildren;
}
export const PopoverCell = ({ value, children }: PopoverCellProps) => {
  const [show, setShow] = useState(false);
  const target = useRef(null);
  const toggleShow = useCallback(() => setShow(!show), [show]);
  return (
    <>
      <span ref={target} className="editable" onClick={toggleShow}>
        {value}
      </span>
      {show && (
        <Overlay
          target={target.current}
          show={show}
          placement="auto"
          rootClose={true}
          onHide={() => setShow(false)}
          flip={true}
        >
          {children}
        </Overlay>
      )}
    </>
  );
};
export { Popover };
